module.exports = __webpack_public_path__ + "static/media/1.e169a7d3.jpg";